export enum WaitlistLinkStatus {
    invalid = 'WAITLIST_LINK_INVALID',
    expired = 'WAITLIST_LINK_EXPIRED',
    used = 'WAITLIST_LINK_USED',
    canceled = 'WAITLIST_LINK_CANCELED',
}

export const WAITLIST_RELEASE_SERVER_ERRORS = [
    WaitlistLinkStatus.invalid,
    WaitlistLinkStatus.expired,
    WaitlistLinkStatus.used,
    WaitlistLinkStatus.canceled,
];

export enum WaitlistStatus {
    error = 'waitlistError',
    disabled = 'waitlistDisabled',
}
